import { useEffect } from "react";
import { BRAND, CARD_COLORS } from "../constants";
import { getCardLayout } from "../utils/cardLayout.js";
import ShareMenu from "./ShareMenu.jsx";

export default function ExpandedCard({ tribute, onClose, allTributes, onNavigate, cardIndex, skipAnimation }) {
  var colors = CARD_COLORS[tribute.variant % CARD_COLORS.length];
  var msgLen = tribute.message.length;

  var { rotation } = getCardLayout(tribute.id, cardIndex);

  var otherTributes = allTributes.filter(function(t) {
    return t.teacher === tribute.teacher && t.id !== tribute.id;
  });

  useEffect(function() {
    var handleKey = function(e) {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return function() { window.removeEventListener("keydown", handleKey); };
  }, [onClose]);

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "rgba(0,0,0,0.35)",
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
        animation: skipAnimation ? "none" : "fadeIn 0.4s ease",
      }}
    >
      <div
        onClick={function(e) { e.stopPropagation(); }}
        style={{
          background: colors.bg,
          border: "1.5px solid " + colors.border,
          borderRadius: "10px",
          padding: "40px 44px",
          maxWidth: "500px",
          width: "100%",
          boxShadow: "0 24px 64px rgba(0,0,0,0.2), 0 4px 16px rgba(0,0,0,0.08)",
          animation: skipAnimation ? "none" : "cardPop 0.7s cubic-bezier(0.34, 1.3, 0.64, 1)",
          position: "relative",
          transform: "rotate(" + rotation + "deg)",
          "--card-rotation": rotation + "deg",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute", top: "14px", right: "14px",
            background: "rgba(0,0,0,0.06)", border: "none", borderRadius: "50%",
            width: "32px", height: "32px", cursor: "pointer", fontSize: "15px",
            color: "#999", display: "flex", alignItems: "center", justifyContent: "center",
            transition: "background 0.15s",
          }}
          onMouseOver={function(e) { e.target.style.background = "rgba(0,0,0,0.1)"; }}
          onMouseOut={function(e) { e.target.style.background = "rgba(0,0,0,0.06)"; }}
        >{"\u2715"}</button>

        <div style={{ lineHeight: 1.7, marginBottom: "20px" }}>
          <div style={{ fontSize: "16px", color: "#555" }}>
            To: <span style={{ color: "#1A1A1A", fontWeight: 600 }}>{tribute.teacher}</span>
          </div>
          <div style={{ fontSize: "16px", color: "#555" }}>
            From: <span style={{ color: "#1A1A1A" }}>{tribute.from}</span>
          </div>
          <div style={{ fontSize: "13px", color: BRAND.primary, marginTop: "2px" }}>
            {tribute.school}
          </div>
        </div>

        <div style={{
          fontFamily: "'Caveat', cursive",
          fontSize: msgLen < 30 ? "44px" : msgLen < 60 ? "36px" : "28px",
          fontWeight: 500,
          color: "#1A1A1A",
          lineHeight: 1.3,
          marginBottom: "24px",
        }}>
          {tribute.message}
        </div>

        {otherTributes.length > 0 && (
          <div style={{
            borderTop: "1px solid rgba(0,0,0,0.07)",
            paddingTop: "16px",
            marginBottom: "16px",
          }}>
            <div style={{ fontSize: "12px", color: "#AAA", marginBottom: "10px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
              More tributes for {tribute.teacher}
            </div>
            {otherTributes.map(function(ot) {
              return (
                <div
                  key={ot.id}
                  onClick={function() { onNavigate(ot.id); }}
                  style={{
                    padding: "10px 14px",
                    background: "rgba(0,0,0,0.03)",
                    borderRadius: "6px",
                    marginBottom: "6px",
                    cursor: "pointer",
                    transition: "background 0.15s",
                  }}
                  onMouseOver={function(e) { e.currentTarget.style.background = "rgba(0,0,0,0.06)"; }}
                  onMouseOut={function(e) { e.currentTarget.style.background = "rgba(0,0,0,0.03)"; }}
                >
                  <div style={{
                    fontFamily: "'Caveat', cursive",
                    fontSize: "18px",
                    fontWeight: 500,
                    color: "#333",
                    marginBottom: "2px",
                  }}>
                    {ot.message.length > 50 ? ot.message.substring(0, 50) + "..." : ot.message}
                  </div>
                  <div style={{ fontSize: "12px", color: "#999" }}>{"\u2014 " + ot.from}</div>
                </div>
              );
            })}
          </div>
        )}

        <div style={{
          borderTop: "1px solid rgba(0,0,0,0.07)",
          paddingTop: "14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}>
          <span style={{ fontSize: "12px", color: "#BBB" }}>
            <a href="https://www.decatureducationfoundation.org" target="_blank" rel="noopener"
              style={{ color: BRAND.primary, textDecoration: "none", opacity: 0.7 }}>
              Decatur Education Foundation
            </a>
          </span>
          <ShareMenu tribute={tribute} />
        </div>
      </div>
    </div>
  );
}
